import React, { ReactNode } from 'react'
import { AvatarInner, NestedAvatar } from '../../common/Avatar'
import { PostAuthor, PostSociety } from '../../../generated/api/post-row'

interface PostAvatarProps {
  role: string
  author?: PostAuthor
  society: Pick<PostSociety, 'coverUrl'>
  userHasMultipleSocieties?: boolean
  onClick?: () => void
  avatarSize?: 'sm' | 'md'
}

export const PostAvatar = ({
  role,
  author,
  society,
  userHasMultipleSocieties,
  onClick,
  avatarSize = 'md',
}: PostAvatarProps): ReactNode => {
  const primarySize = avatarSize === 'md' ? 40 : 30
  const secondarySize = avatarSize === 'md' ? 20 : 18

  const societyAvatar = (size: number): JSX.Element => (
    <AvatarInner placeholder="society" url={society.coverUrl} size={size} />
  )
  const userAvatar = (size: number, click?: () => void): JSX.Element => (
    <AvatarInner
      alt={author ? `${author.fullName} avatar` : 'avatar'}
      url={author?.avatarUrl}
      initials={author?.initials}
      size={size}
      onClick={click}
    />
  )

  if (role === 'admin-society' || role === 'board-society') {
    return societyAvatar(primarySize)
  }

  const nested = role === 'admin' || role === 'board-member'
  const inverted = !nested && userHasMultipleSocieties

  if (!nested && !inverted) {
    return userAvatar(primarySize, onClick)
  }

  return (
    <NestedAvatar
      primaryAvatar={
        inverted ? userAvatar(primarySize) : societyAvatar(primarySize)
      }
      secondaryAvatar={
        inverted ? societyAvatar(secondarySize) : userAvatar(secondarySize)
      }
      avatarSize={avatarSize}
      onClick={onClick}
    />
  )
}
